import React, { useState } from "react";
import {
  Paper,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ClearIcon from "@mui/icons-material/Clear";

const BulkActionBar = ({ selectedCount, onReboot, onClear, isRebooting }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (selectedCount === 0) return null;

  return (
    <>
      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1300,
          px: 3,
          py: 1.5,
          borderRadius: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="body2" fontWeight="bold">
          {selectedCount} device{selectedCount > 1 ? "s" : ""} selected
        </Typography>
        <Button
          variant="contained"
          color="warning"
          size="small"
          startIcon={<RestartAltIcon />}
          onClick={() => setConfirmOpen(true)}
          disabled={isRebooting}
        >
          {isRebooting ? "Rebooting..." : "Reboot"}
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ClearIcon />}
          onClick={onClear}
        >
          Clear
        </Button>
      </Paper>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Bulk Reboot</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reboot {selectedCount} device
            {selectedCount > 1 ? "s" : ""}? This will interrupt any active
            connections.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="warning"
            onClick={() => {
              setConfirmOpen(false);
              onReboot();
            }}
          >
            Reboot
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkActionBar;
